import React, { useState, useEffect } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Modal } from "react-bootstrap";
import $ from "jquery";
import Resizer from "react-image-file-resizer";
import Loader from "../Utils/Loader";
let files;
function CatimgUpload(props) {
  const [src, setsrc] = useState();
  const [show, setshow] = useState();
  const [loader, setLoader] = useState(false);
  const [cropper, setCropper] = useState();
  const [name, setName] = useState("");
  const [error, seterror] = useState("");
  const [cropResult, setcropResult] = useState("assets/images/upload-img.png");

  function Validate(target) {
    var Isvalid = true;
    let file = target.files[0];
    const acceptedFileTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    console.log(acceptedFileTypes.includes(file.type));

    if (!acceptedFileTypes.includes(file.type)) {
      Isvalid = false;
      seterror("Please upload a valid image or PDF.");
    } else if (file.size > 1024 * 1024 * 5) {
      Isvalid = false;
      seterror("Sorry, you can upload photo up to 5 MB.");
    }

    return Isvalid;
  }

  function onChange(e) {
    try {
      if (!Validate(e.target)) return;
      const file = e.target.files[0];
      if (!file) return;
      setLoader(true);

      seterror("");
      setName(file.name);

      const reader = new FileReader();
      if (file.type === "application/pdf") {
        reader.onload = () => {
          const data = {
            url: reader.result,
            name: file.name,
          };
          props.parentCallback(data);
          setLoader(false);
        };
        reader.onerror = (error) => {
          setLoader(false);
          throw new Error("Error reading file: " + error.message);
        };
        reader.readAsDataURL(file);
        console.log("rt");
      } else {
        const img = new Image();
        img.onload = () => {
          Resizer.imageFileResizer(
            file,
            img.width,
            img.height,
            "PNG",
            25,
            0,
            (resizedFile) => {
              setLoader(false);
              console.log("resizedFile", resizedFile);
              setsrc(resizedFile);
              setshow(true);
            },
            "base64"
          );
        };
        img.onerror = (error) => {
          setLoader(false);
          throw new Error("Failed to load image: " + error.message);
        };
        img.src = URL.createObjectURL(file);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setLoader(false);
    }
  }
  // function onChange(e) {
  //   try {
  //     if (!Validate(e.target)) return;

  //     const file = e.target.files[0];
  //     if (!file) return;

  //     seterror("");
  //     setName(file.name);

  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       const data = {
  //         url: reader.result,
  //         name: name,
  //       };
  //       if (file.type === "application/pdf") {
  //         props.parentCallback(data);
  //       } else {
  //         const img = new Image();
  //         img.onload = () => {
  //           Resizer.imageFileResizer(
  //             file,
  //             img.width,
  //             img.height,
  //             "PNG",
  //             25,
  //             0,
  //             (resizedFile) => {
  //               setsrc(resizedFile);
  //               setshow(true);
  //             },
  //             "base64"
  //           );
  //         };
  //         img.onerror = (error) => {
  //           throw new Error("Failed to load image: " + error.message);
  //         };
  //         img.src = reader.result;
  //         setshow(true);
  //       }
  //     };
  //     reader.onerror = (error) => {
  //       throw new Error("Error reading file: " + error.message);
  //     };
  //     reader.readAsDataURL(file);
  //   } catch (error) {
  //     console.error("An error occurred:", error);
  //   }
  // }

  function handlemodal() {
    setshow(!show);

    $('input[type="file"]').val("");
  }

  // const getCroppedBase64 = async () => {
  //   return new Promise((resolve) => {
  //     cropper.getCroppedCanvas({ maxWidth: 1000, maxHeight: 1000 }).toBlob(
  //       (blob) => {
  //         const reader = new FileReader();
  //         reader.readAsDataURL(blob);
  //         reader.onloadend = () => resolve(reader.result); // Properly return Base64
  //       },
  //       "image/jpeg",
  //       0.7
  //     );
  //   });
  // };

  async function cropImage() {
    if (typeof cropper.getCroppedCanvas() === "undefined") {
      return;
    }
    try {
      setLoader(true);
      let bs64 = cropper
        .getCroppedCanvas({ maxWidth: 800, maxHeight: 800 })
        .toDataURL();

      setcropResult(bs64);
      setshow(false);

      $('input[type="file"]').val("");

      const data = {
        url: bs64,
        name: name,
      };
      props.parentCallback(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  }

  return (
    <div>
      {loader && <Loader />}
      <div className="row strip-div">
        <div className="col-12">
          {/* <label htmlFor="image"> */}
          <input
            type="file"
            name="image"
            id="image"
            accept="image/*,.pdf,application/pdf"
            className="form-control d-none"
            onChange={onChange}
          />
          <label className="catlg-addimg" htmlFor="image">
            <span className="mticon">
              <span className="material-symbols-outlined">add_a_photo</span>
            </span>{" "}
            Upload document
          </label>
        </div>
        <div className="text-danger">{error}</div>
      </div>
      <Modal
        show={show}
        onHide={handlemodal}
        className="crp-mdl"
        backdrop="static"
      >
        <Modal.Header closeButton></Modal.Header>
        <Cropper
          style={{ width: "100%", height: "100%" }}
          //  initialAspectRatio={1}
          preview=".img-preview"
          guides={false}
          background={false}
          movable={false}
          zoomable={false}
          src={src}
          cropBoxResizable={true}
          onInitialized={(instance) => {
            setCropper(instance);
          }}
          viewMode={1}
          dragMode="move"
          minCropBoxWidth={100}
          minCropBoxHeight={100}
          autoCropArea={1}
        />
        <button
          onClick={cropImage}
          className="submitbtn mb-0"
          style={{ borderRadius: "0" }}
        >
          Save Image
        </button>
      </Modal>
    </div>
  );
}

export default CatimgUpload;
